import { BaseControl, BaseControlProps, Chip, MenuItemProps } from "@bsm/component";
import { useCallback } from "react";

export const ItemsControl = (props: Props) => {

    const optionIsSelected = useCallback((item: MenuItemProps) => {
        if(props.multiple) {
            return props.value?.includes(item.value)
        }
       
        return item.value === props.value
    }, [props.value])

    const onSelectItem = useCallback((option: MenuItemProps) => () => {
        if(!props?.multiple) {
            props.onChange(option.value)
            return
        }

        props.onChange(
            props.value?.includes(option.value)
            ? props.value?.filter(
                (item) => item !== option.value
            )
            : [...props.value, option.value]
        )
    }, [props.value])

    return (
        <BaseControl {...props}>
            <div className="flex gap-2 flex-wrap">
                {!props.readonly &&
                    props?.options.map((option, index) => (
                        <Chip
                            key={`item-custom-${index}`}
                            label={option.label}
                            className={`${optionIsSelected(option) ? "bg-primary text-white" : "bg-default"}`}
                            onClick={onSelectItem(option)}
                        />
                    ))}
                {props.readonly &&
                    props?.options
                        .filter((option) => props.value?.includes(option.value))
                        .map((option, index) => (
                            <Chip
                                key={`item-custom-${index}`}
                                label={option.label}         
                            />
                        ))}
            </div>
        </BaseControl>
    );
};

type Props = BaseControlProps & {
    options?: Array<MenuItemProps>;
    multiple?: boolean;
    value?: Array<number>;
    onChange: (value: Props["value"]) => void;
};
